"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const reducers_1 = require("../../../reducers");
const testDevices_1 = require("../../../actions/testDevices");
const DeleteTestDevicesConfirmationDialog = ({ selectedTestDeviceIds, dispatch, close, device, }) => {
    const deviceOrDevices = selectedTestDeviceIds.length > 1 ? 'devices' : 'device';
    const dialogText = `You're about to remove ${selectedTestDeviceIds.length} ` +
        `${deviceOrDevices} from your list of test devices. Continue?`;
    return (React.createElement(src_1.Dialog, { buttonPrimaryText: "Cancel", buttonSecondaryText: "Remove Devices", primaryOnClick: () => {
            close();
        }, secondaryOnClick: () => {
            dispatch(testDevices_1.deleteTestDevices(selectedTestDeviceIds));
            close();
        }, isOpen: true, dialogText: dialogText, targetParent: device === 'Desktop' ? 'mainModalView' : 'mainModalLeft', childStyle: {
            marginBottom: 32,
        } }));
};
const mapStateToProps = (state) => ({
    selectedTestDeviceIds: reducers_1.getSelectedTestDevices(state),
});
exports.default = react_redux_1.connect(mapStateToProps)(DeleteTestDevicesConfirmationDialog);
